module.exports = __webpack_public_path__ + "img/wodeicon.50ab2d64.png";